<script lang="ts">
  import Footer from "./footer/Footer.svelte";
  import Navbar from "./header/Navbar.svelte";
  import { appManager } from "./AppManagerStore";
  import AngleBottom from "./svg/shapes/AngleBottom.svelte";
  import AngleTop from "./svg/shapes/AngleTop.svelte";
  import BlogCarousel from "./blog/carousel/BlogCarousel.svelte";
  import { _ } from "svelte-i18n";
  import ProvenApproach from "./ProvenApproach.svelte";
  import { onMount } from "svelte";
  import { writable } from "svelte/store";
  import WhySection from "./WhySection.svelte";
  import CyclingSection from "./CyclingSection.svelte";
  import GisIntegrationSection from "./GisIntegrationSection.svelte";
    import HowSection from "./HowSection.svelte";

  const format = (value: number) => {
    if (value > 10000) {
      return `${format(Math.round(value / 1000))}k`;
    }
    return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
  };

  const projects = writable(format(483));
  const scenarios = writable(format(1472));
  const edits = writable(format(21146));

  onMount(async () => {
    const projectStatusResponse = await fetch(
      "https://api.anyways.eu/impact/stats",
    );
    if (projectStatusResponse.ok) {
      const projectStatus = (await projectStatusResponse.json()) as {
        projectCount: number;
        scenarioCount: number;
        matrixCount: number;
      };

      $projects = format(projectStatus.projectCount);
      $scenarios = format(projectStatus.scenarioCount);
    }

    const editStatusResponse = await fetch("https://api.anyways.eu/edit/stats");
    if (editStatusResponse.ok) {
      const editStatus = (await editStatusResponse.json()) as {
        branchCommitCount: number;
      };

      $edits = format(editStatus.branchCommitCount);
    }
  });
</script>

<Navbar background="none" isFluid={false} text="white" />

<section
  class="py-13 mt-n12"
  style="background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.7),rgba(0, 0, 0, 0.7)), url(img/covers/cover-schools-netherlands.jpg); background-size: cover;"
>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-10 col-lg-8">
        <div class="mt-0 mb-0 lh-1">
          <div class="display-1 text-white mb-0 lh-1" id="welcomeHeadingSource">
            {$_("home.title.part1")} <span class="text-primary fw-bold">{$_("home.title.part2")}<br>{$_("home.title.part3")}</span> 
          </div>
          <span class="display-4 text-white lh-1">{$_("home.title.part4")}</span>
          <br><span class="display-1 text-white fw-bold lh-1">{$_("home.title.part5")}</span>
        </div>

        <p class="lead text-white mb-3">
          {$_("home.subtitle.part1")}
        </p>

        <div class="d-flex mb-5">
          <div class="pe-5">
            <h1 class="fw-bold text-primary-desat mb-0">
              <span class="aos-init aos-animate">{format($projects)}</span>
            </h1>
            <p class="text-white mb-0">{$_("home.projects")}</p>
          </div>
          <div class="px-5">
            <h1 class="fw-bold text-primary-desat mb-0">
              <span class="aos-init aos-animate">{format($scenarios)}</span>
            </h1>
            <p class="text-white mb-0">{$_("home.scenarios")}</p>
          </div>
          <div class="ps-5">
            <h1 class="fw-bold text-primary-desat mb-0">
              <span class="aos-init aos-animate">{format($edits)}</span>
            </h1>
            <p class="text-white mb-0">{$_("home.edits")}</p>
          </div>
        </div>

        <p class="mb-3 mb-md-9">
          <a
            class="btn btn-primary shadow lift"
            href="{$appManager.PublicUrl}signup"
          >
            {$_("general.startfree")} <i class="fe fe-arrow-right ms-3" />
          </a>
          <a href="#edittestpublish" class="btn btn-primary-soft lift">
            {$_("general.learnmore")}
          </a>
        </p>
      </div>

      <div class="col-12 col-lg-4">
        <div class="container h-100 p-0">
          <div class="row align-items-center lead text-white mb-3">
            <div class="col-12">
              <i class="fe fe-check me-2" />{$_("home.features.feature1")}
            </div>
            <div class="col-12">
              <i class="fe fe-check me-2" />{$_("home.features.feature2")}
            </div>
            <div class="col-12">
              <i class="fe fe-check me-2" />{$_("home.features.feature3")}
            </div>
            <div class="col-12">
              <i class="fe fe-check me-2" />{$_("home.features.feature4")}
            </div>
            <div class="col-12">
              <i class="fe fe-check me-2" />{$_("home.features.feature5")}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="position-relative">
  <div class="shape shape-bottom shape-fluid-x text-black">
    <AngleBottom />
  </div>
</div>

<HowSection />

<div class="position-relative">
  <div class="shape shape-top shape-fluid-x shape-flip-x text-black">
    <AngleTop />
  </div>
</div>

<WhySection />

<CyclingSection />

<GisIntegrationSection />

<ProvenApproach />

<BlogCarousel />

<Footer bgClass="bg-black" />

<style>
  .shape:not([class*="shape-blur"]) > * {
    transform: scale(1);
  }

  .display-1-bigger {
    font-size: 4.5rem;
    font-weight: 400;
  }
</style>
